import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { GET_SUBSCRIPTION } from 'actions/subscription';

function* getSubscription(action) {
  try {
    const response = yield call(API.getSubscription, action.payload);
    yield put({ type: GET_SUBSCRIPTION.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: GET_SUBSCRIPTION.FAIL, payload: { error: e } });
  }
}

function* subscription() {
  yield takeLatest(GET_SUBSCRIPTION.REQUEST, getSubscription);
}
export default subscription;
